import apiClient from "./client";

export const studentServices = {
  getByToken: () => apiClient.get("/student/profile"),
  updateProfile: (payload) =>
    apiClient.post("/student/profile/update", payload),
};
